import { render, staticRenderFns } from "./AntonymsForm.vue?vue&type=template&id=43f3901e&scoped=true&lang=pug&"
import script from "./AntonymsForm.vue?vue&type=script&lang=js&"
export * from "./AntonymsForm.vue?vue&type=script&lang=js&"
import style0 from "./AntonymsForm.vue?vue&type=style&index=0&id=43f3901e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f3901e",
  null
  
)

export default component.exports